var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForm03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Form-03__Icn/40px/Legende/Form-03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Form-03__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Legende_Form-03__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,12 L27,26 L13,26 L20,12 Z M20,16.471 L16.235,24 L23.764,24 L20,16.471 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Form-03__Triangle"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm03);
export default __webpack_public_path__ + "static/media/Form-03.0839d862b67cd7de85072e26f8708e50.svg";
export { ForwardRef as ReactComponent };